module.exports = __webpack_public_path__ + "img/animation-poster.f4d3c79.jpg";